!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@hotmart/cosmos"] = t() : e["@hotmart/cosmos"] = t();
}(self, function () {
  return (() => {
    "use strict";

    var e = {
        7705: e => {
          e.exports = function (e) {
            var t = [];
            return t.toString = function () {
              return this.map(function (t) {
                var n = "",
                  o = void 0 !== t[5];
                return t[4] && (n += "@supports (".concat(t[4], ") {")), t[2] && (n += "@media ".concat(t[2], " {")), o && (n += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), n += e(t), o && (n += "}"), t[2] && (n += "}"), t[4] && (n += "}"), n;
              }).join("");
            }, t.i = function (e, n, o, r, i) {
              "string" == typeof e && (e = [[null, e, void 0]]);
              var c = {};
              if (o) for (var a = 0; a < this.length; a++) {
                var u = this[a][0];
                null != u && (c[u] = !0);
              }
              for (var s = 0; s < e.length; s++) {
                var l = [].concat(e[s]);
                o && c[l[0]] || (void 0 !== i && (void 0 === l[5] || (l[1] = "@layer".concat(l[5].length > 0 ? " ".concat(l[5]) : "", " {").concat(l[1], "}")), l[5] = i), n && (l[2] ? (l[1] = "@media ".concat(l[2], " {").concat(l[1], "}"), l[2] = n) : l[2] = n), r && (l[4] ? (l[1] = "@supports (".concat(l[4], ") {").concat(l[1], "}"), l[4] = r) : l[4] = "".concat(r)), t.push(l));
              }
            }, t;
          };
        },
        6738: e => {
          e.exports = function (e) {
            return e[1];
          };
        },
        5097: (e, t, n) => {
          n.d(t, {
            Z: () => a
          });
          var o = n(6738),
            r = n.n(o),
            i = n(7705),
            c = n.n(i)()(r());
          c.push([e.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
          const a = c;
        }
      },
      t = {};
    function n(o) {
      var r = t[o];
      if (void 0 !== r) return r.exports;
      var i = t[o] = {
        id: o,
        exports: {}
      };
      return e[o](i, i.exports, n), i.exports;
    }
    n.n = e => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return n.d(t, {
        a: t
      }), t;
    }, n.d = (e, t) => {
      for (var o in t) n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: t[o]
      });
    }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var o = {};
    return (() => {
      n.r(o);
      const e = require("@babel/runtime/helpers/classCallCheck");
      var t = n.n(e);
      const r = require("@babel/runtime/helpers/createClass");
      var i = n.n(r);
      const c = require("@babel/runtime/helpers/assertThisInitialized");
      var a = n.n(c);
      const u = require("@babel/runtime/helpers/get");
      var s = n.n(u);
      const l = require("@babel/runtime/helpers/inherits");
      var f = n.n(l);
      const p = require("@babel/runtime/helpers/possibleConstructorReturn");
      var d = n.n(p);
      const h = require("@babel/runtime/helpers/getPrototypeOf");
      var m = n.n(h);
      const v = require("@babel/runtime/helpers/wrapNativeSuper");
      var y = n.n(v),
        b = n(5097);
      var S,
        g,
        w = function (e) {
          f()(c, e);
          var n,
            o,
            r = (n = c, o = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }(), function () {
              var e,
                t = m()(n);
              if (o) {
                var r = m()(this).constructor;
                e = Reflect.construct(t, arguments, r);
              } else e = t.apply(this, arguments);
              return d()(this, e);
            });
          function c(e) {
            var n;
            t()(this, c);
            var o = (n = r.call(this)).getTemplate(),
              i = document.createElement("template");
            i.innerHTML = o;
            var a = i.content.querySelector("style");
            return a && (a.innerHTML = "".concat(a.innerHTML, " ").concat(b.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(i, e), n.attachShadow({
              mode: "open"
            }), n.shadowRoot.appendChild(document.importNode(i.content, !0)), n;
          }
          return i()(c, [{
            key: "connectedCallback",
            value: function () {
              window.ShadyCSS && window.ShadyCSS.styleElement(this);
            }
          }, {
            key: "getTemplate",
            value: function () {
              return "";
            }
          }]), c;
        }(y()(HTMLElement)),
        C = "hot-structure",
        x = "openmenu",
        O = "closemenu";
      S = C, g = function (e) {
        f()(c, e);
        var n,
          o,
          r = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = m()(n);
            if (o) {
              var r = m()(this).constructor;
              e = Reflect.construct(t, arguments, r);
            } else e = t.apply(this, arguments);
            return d()(this, e);
          });
        function c() {
          var e;
          return t()(this, c), (e = r.call(this, C))._menuOpened = !1, e._onOpenMenu = e._onOpenMenu.bind(a()(e)), e._onCloseMenu = e._onCloseMenu.bind(a()(e)), e;
        }
        return i()(c, [{
          key: "connectedCallback",
          value: function () {
            s()(m()(c.prototype), "connectedCallback", this).call(this), window.addEventListener(x, this._onOpenMenu), window.addEventListener(O, this._onCloseMenu);
          }
        }, {
          key: "disconnectedCallback",
          value: function () {
            window.removeEventListener(x, this._onOpenMenu), window.removeEventListener(O, this._onCloseMenu);
          }
        }, {
          key: "_onOpenMenu",
          value: function () {
            this._menuOpened = !0;
          }
        }, {
          key: "_onCloseMenu",
          value: function () {
            this._menuOpened = !1;
          }
        }, {
          key: "getState",
          value: function () {
            return {
              menuOpened: this._menuOpened
            };
          }
        }, {
          key: "getTemplate",
          value: function () {
            return '\n      <slot name="menu"></slot>\n      <slot name="content"></slot>\n    ';
          }
        }]), c;
      }(w), customElements.get(S) || customElements.define(S, g);
    })(), o;
  })();
});